import Hero01 from "./Hero01";
import Quote01 from "./Quote01";
import Grid01 from "./Grid01";
import How01 from "./How01";
import Who01 from "./Who01";
import Pricing01 from "./Pricing01";
import Faq01 from "./Faq01";
import Cta01 from "./Cta01";

import SeoHead from "../../../seo/SeoHead";
import { HOME_PAGE_DESCRIPTION, HOME_PAGE_TITLE } from "../../../seo/siteConfig";

function main() {
  return (
    <div>
      <SeoHead
        title={HOME_PAGE_TITLE}
        description={HOME_PAGE_DESCRIPTION}
        path="/"
      />
      <Hero01 />

      <Quote01 />
      <Who01 />
      <Grid01 />
      <How01 />

      <Pricing01 />
      <Faq01 />
      <Cta01 />
    </div>
  );
}

export default main;
